import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateComplainStatus } from "@/lib/api/complain.api"
import { useAuthStore } from "@/store/auth.store"

export function useUpdateComplainStatus() {
  const queryClient = useQueryClient()
  const accessToken = useAuthStore((s) => s.accessToken)

  return useMutation({
    mutationFn: async ({ id, status, resolutionNote }: { id: string; status: string; resolutionNote?: string }) => {
      if (!accessToken) throw new Error("No token")
      return updateComplainStatus(id, { status, resolutionNote }, accessToken)
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["complain", variables.id] })
      queryClient.invalidateQueries({ queryKey: ["complains"] })
    },
    onError: (err: any) => {
      console.error("Failed to update complaint status", err)
    },
  })
}
